import { APIResource } from 'services'
import { JSONApi } from 'utils'
import { Protect } from 'services/TokenStore'

export const ProtectedJsonAPI = new APIResource('',{},{ decorators: [Protect, JSONApi]})